export const getters = {
  fiscalYears(state) {
    return state.fiscalYears;
  },
  fiscalYearByDate: (state) => (date) => {
    const targetDate = new Date(date);
    const fiscalYear = state.fiscalYears.find((e) => {
      const startDate = new Date(e.fromDate);
      const endDate = new Date(e.toDate);
      return targetDate >= startDate && targetDate <= endDate;
    });

    return fiscalYear || null;
  },
};
